import React from 'react';
import { Loader } from 'lucide-react';

interface PortalSectionProps {
  title: string;
  loading?: boolean;
  error?: string | null;
  children?: React.ReactNode;
}

/** Screen frame: the page heading plus loading and error states. Fills the content column up to a readable width. */
const PortalSection: React.FC<PortalSectionProps> = ({ title, loading = false, error = null, children }) => (
  <section aria-labelledby="portal-screen-title" className="mx-auto w-full max-w-5xl px-4 py-6 sm:px-6 lg:py-8">
    <h1 id="portal-screen-title" className="mb-5 text-2xl font-semibold tracking-tight text-slate-900">
      {title}
    </h1>
    {loading ? (
      <div role="status" aria-live="polite" className="flex items-center gap-2 py-8 text-slate-700">
        <Loader size={20} className="animate-spin text-teal-700" aria-hidden="true" />
        <span>Loading</span>
      </div>
    ) : error ? (
      <p role="alert" className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800">
        {error}
      </p>
    ) : (
      children
    )}
  </section>
);

export const EmptyState: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className="rounded-xl border border-dashed border-slate-300 bg-white p-6 text-center text-sm text-slate-700">{children}</p>
);

export const Card: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = '' }) => (
  <div className={`rounded-xl border border-slate-200 bg-white p-4 shadow-sm sm:p-5 ${className}`}>{children}</div>
);

export default PortalSection;
